/*
 * @Author: junrui_lv junrui_lv@lebo.cn
 * @Date: 2023-11-03 11:35:24
 * @LastEditors: ljr junrui_lv@lebo.cn
 * @LastEditTime: 2023-11-13 20:45:50
 * @FilePath: /web-SaaS/src/directive/authority.js
 * @Description: 广告结算模块的用户权限控制
 */
const checkAuth = (authName, userAuthList) => {
  let hasAuth = true;
  if (authName) {
    //判断是否是数组。有时候权限需要多重支持 以['权限1','权限2'] 格式的也可以被认证
    if (authName instanceof Array && authName.length > 0) {
      hasAuth = userAuthList.some(it =>
        //includes:查找
        authName.includes(it)
      );
    } else {
      hasAuth = userAuthList.some(item => item === authName);
    }
  }
  return hasAuth;
}

export default (Vue) => {
  Vue.directive('authority', {
    inserted: (el, { value }) => {
      const authList = window.localStorage.getItem('adUserAuthList').split(',') || []
      const hasAuth = checkAuth(value, authList);
      if (!hasAuth) {
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        } else {
          el.innerHTML = "";
        }
      } else {
        el && el.setAttribute("code", value);
      }
    },
    update: (el, { value }) => {
      const authList = window.localStorage.getItem('adUserAuthList').split(',') || []
      const hasAuth = checkAuth(value, authList);
      if (!hasAuth) {
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        } else {
          el.innerHTML = "";
        }
      } else {
        el && el.setAttribute("code", value);
      }
    }
  })
}
